import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import {
    Toolbar,
    Grid,
    Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import DirectionsCarOutlinedIcon from '@material-ui/icons/DirectionsCarOutlined';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import SecurityOutlinedIcon from '@material-ui/icons/SecurityOutlined';
import logoIcon from '../../assets/img/logo-icon.png';

import SideMenu from '../../components/SideMenu';
import { PermissionsContext } from '../../providers/Permissions';
import storage from '../../utils/storage';

const shortcuts = [
    {
        route: '/dashboard',
        title: 'Dashboard',
        description: 'Acompanhe os principais indicadores e eventos do ambiente.',
        icon: DashboardOutlinedIcon,
        color: '#2563eb',
        background: '#dbeafe',
    },
    {
        route: '/pessoa',
        title: 'Pessoas',
        description: 'Consulte cadastros, vínculos e informações de acesso.',
        icon: PeopleOutlineIcon,
        color: '#7c3aed',
        background: '#ede9fe',
    },
    {
        route: '/relatorio_unificado',
        title: 'Relatório unificado',
        description: 'Analise eventos de acesso com filtros detalhados.',
        icon: AssessmentOutlinedIcon,
        color: '#059669',
        background: '#d1fae5',
    },
    {
        route: '/relatorio_veiculos',
        title: 'Relatório de veículos',
        description: 'Visualize registros, placas e movimentações de veículos.',
        icon: DirectionsCarOutlinedIcon,
        color: '#d97706',
        background: '#fef3c7',
    },
];

export default function Home() {
    const classes = useStyles();
    const { PermissionWrapper } = useContext(PermissionsContext);

    const currentHour = new Date().getHours();
    const greeting = currentHour < 12
        ? 'Bom dia'
        : currentHour < 18
            ? 'Boa tarde'
            : 'Boa noite';
    const firstName = storage.getItem('@Identifik:user')?.name?.split(' ')[0];

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <div className={classes.pageContainer}>
                    <section className={classes.hero}>
                        <div className={classes.heroDecorationOne} />
                        <div className={classes.heroDecorationTwo} />

                        <div className={classes.heroContent}>
                            
                            <Typography component="h1" className={classes.heroTitle}>
                                {greeting}{firstName ? `, ${firstName}` : ''}.
                            </Typography>
                            <Typography className={classes.heroSubtitle}>
                                Bem-vindo ao SecureCloud. Acesse rapidamente as áreas mais utilizadas
                                e mantenha sua operação organizada em um só lugar.
                            </Typography>
                        </div>

                        <div className={classes.heroVisual} aria-hidden="true">
                            <div className={classes.securityOrb}>
                                <img src={logoIcon} alt="SecureCloud"  />
                            </div>
                            
                        </div>
                    </section>

                    <section className={classes.shortcutsSection}>
                        <div className={classes.sectionHeader}>
                            <div>
                                <Typography className={classes.sectionTitle}>
                                    Acesso rápido
                                </Typography>
                                <Typography className={classes.sectionSubtitle}>
                                    Continue seu trabalho pelas principais áreas do sistema.
                                </Typography>
                            </div>
                        </div>

                        <Grid container spacing={2}>
                            {shortcuts.map(({ route, title, description, icon: Icon, color, background }) => (
                                <PermissionWrapper route={route} key={route}>
                                    <Grid item xs={12} sm={6} lg={3}>
                                        <Link to={route} className={classes.shortcutCard}>
                                            <div
                                                className={classes.shortcutIcon}
                                                style={{ color, backgroundColor: background }}
                                            >
                                                <Icon />
                                            </div>
                                            <div className={classes.shortcutContent}>
                                                <Typography className={classes.shortcutTitle}>
                                                    {title}
                                                </Typography>
                                                <Typography className={classes.shortcutDescription}>
                                                    {description}
                                                </Typography>
                                            </div>
                                            <div className={classes.shortcutAction}>
                                                <span>Acessar</span>
                                                <ArrowForwardIcon />
                                            </div>
                                        </Link>
                                    </Grid>
                                </PermissionWrapper>
                            ))}
                        </Grid>
                    </section>

                    <div className={classes.footerHint}>
                        <SecurityOutlinedIcon />
                        <Typography>
                            Utilize o menu lateral para acessar todas as funcionalidades disponíveis no seu perfil.
                        </Typography>
                    </div>
                </div>
            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    content: {
        flexGrow: 1,
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
        minWidth: 0,
        padding: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    pageContainer: {
        margin: '0 auto',
        maxWidth: 1280,
    },
    hero: {
        background: 'linear-gradient(135deg, #0f3f86 0%, #1769aa 52%, #1e88e5 100%)',
        borderRadius: 20,
        boxShadow: '0 18px 42px rgba(15, 63, 134, .18)',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        minHeight: 290,
        overflow: 'hidden',
        padding: theme.spacing(5),
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            minHeight: 260,
            padding: theme.spacing(4),
        },
        [theme.breakpoints.down('xs')]: {
            borderRadius: 16,
            minHeight: 0,
            padding: theme.spacing(3, 2.5),
        },
    },
    heroDecorationOne: {
        backgroundColor: 'rgba(255, 255, 255, .07)',
        borderRadius: '50%',
        height: 320,
        position: 'absolute',
        right: -80,
        top: -140,
        width: 320,
    },
    heroDecorationTwo: {
        border: '1px solid rgba(255, 255, 255, .12)',
        borderRadius: '50%',
        bottom: -170,
        height: 340,
        position: 'absolute',
        right: 180,
        width: 340,
    },
    heroContent: {
        alignSelf: 'center',
        maxWidth: 650,
        position: 'relative',
        zIndex: 2,
    },
    secureBadge: {
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, .14)',
        border: '1px solid rgba(255, 255, 255, .2)',
        borderRadius: 999,
        display: 'inline-flex',
        fontSize: '.72rem',
        fontWeight: 700,
        gap: theme.spacing(.75),
        letterSpacing: '.04em',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(.65, 1.25),
        textTransform: 'uppercase',
        '& svg': {
            fontSize: 17,
        },
    },
    heroTitle: {
        fontSize: '2.35rem',
        fontWeight: 700,
        letterSpacing: '-.025em',
        lineHeight: 1.15,
        [theme.breakpoints.down('sm')]: {
            fontSize: '2rem',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.7rem',
        },
    },
    heroSubtitle: {
        color: 'rgba(255, 255, 255, .82)',
        fontSize: '1rem',
        lineHeight: 1.65,
        marginTop: theme.spacing(1.5),
        maxWidth: 590,
        [theme.breakpoints.down('xs')]: {
            fontSize: '.88rem',
        },
    },
    heroVisual: {
        alignItems: 'center',
        alignSelf: 'center',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 250,
        position: 'relative',
        zIndex: 2,
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    securityOrb: {
        alignItems: 'center',
        background: 'linear-gradient(145deg, rgba(255,255,255,.25), rgba(255,255,255,.08))',
        border: '1px solid rgba(255, 255, 255, .26)',
        borderRadius: 28,
        boxShadow: '0 16px 36px rgba(7, 33, 74, .22)',
        display: 'flex',
        height: 96,
        justifyContent: 'center',
        marginBottom: theme.spacing(1.5),
        
        width: 96,
        '& svg': {
            fontSize: 50,
            transform: 'rotate(4deg)',
        },
    },
    heroBrand: {
        fontSize: '1rem',
        fontWeight: 700,
    },
    heroBrandCaption: {
        color: 'rgba(255, 255, 255, .72)',
        fontSize: '.7rem',
        marginTop: 2,
    },
    shortcutsSection: {
        marginTop: theme.spacing(4),
    },
    sectionHeader: {
        alignItems: 'flex-end',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(2),
    },
    sectionTitle: {
        color: '#1e293b',
        fontSize: '1.05rem',
        fontWeight: 700,
    },
    sectionSubtitle: {
        color: '#64748b',
        fontSize: '.8rem',
        marginTop: 2,
    },
    shortcutCard: {
        backgroundColor: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 15,
        color: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 210,
        padding: theme.spacing(2),
        textDecoration: 'none',
        transition: 'border-color .2s ease, box-shadow .2s ease, transform .2s ease',
        '&:hover': {
            borderColor: '#bfdbfe',
            boxShadow: '0 12px 28px rgba(15, 23, 42, .08)',
            transform: 'translateY(-3px)',
        },
        '&:focus-visible': {
            outline: '3px solid rgba(25, 118, 210, .25)',
            outlineOffset: 2,
        },
    },
    shortcutIcon: {
        alignItems: 'center',
        borderRadius: 11,
        display: 'flex',
        height: 42,
        justifyContent: 'center',
        width: 42,
        '& svg': {
            fontSize: 22,
        },
    },
    shortcutContent: {
        flex: 1,
        marginTop: theme.spacing(1.75),
    },
    shortcutTitle: {
        color: '#1e293b',
        fontSize: '.95rem',
        fontWeight: 700,
    },
    shortcutDescription: {
        color: '#64748b',
        fontSize: '.76rem',
        lineHeight: 1.5,
        marginTop: theme.spacing(.5),
    },
    shortcutAction: {
        alignItems: 'center',
        color: '#1976d2',
        display: 'flex',
        fontSize: '.75rem',
        fontWeight: 700,
        gap: theme.spacing(.5),
        marginTop: theme.spacing(1.5),
        '& svg': {
            fontSize: 17,
            transition: 'transform .2s ease',
        },
        '$shortcutCard:hover & svg': {
            transform: 'translateX(3px)',
        },
    },
    footerHint: {
        alignItems: 'center',
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 12,
        color: '#64748b',
        display: 'flex',
        gap: theme.spacing(1),
        marginTop: theme.spacing(3),
        padding: theme.spacing(1.5, 2),
        '& svg': {
            color: '#1976d2',
            flexShrink: 0,
            fontSize: 20,
        },
        '& p': {
            fontSize: '.76rem',
            lineHeight: 1.4,
        },
    },
}));
